import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M12 4.4a.6.6 0 0 1 .6.6v6.4H19a.6.6 0 1 1 0 1.2h-6.4V19a.6.6 0 1 1-1.2 0v-6.4H5a.6.6 0 1 1 0-1.2h6.4V5a.6.6 0 0 1 .6-.6Z"
      clip-rule="evenodd"
    />
  </svg>
`;
